import './scripts/common';
import Tooltip from 'bootstrap/js/dist/tooltip';

import {onFind} from "@elements/init-modules-in-scope";
onFind('[data-bs-toggle="tooltip"]',function (element) {
    new Tooltip(element);
});


let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import * as floatingLabels from '@elements/floating-labels';
floatingLabels.init();

import * as azTeaserSlider from './scripts/az-teaser-slider';
azTeaserSlider.init();

import * as imgTeaserSlider from './scripts/img-teaser-slider';
imgTeaserSlider.init();

import * as imageSlider from './scripts/image-slider';
imageSlider.init();

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init({addUrlParams: true});

import * as multiselectDropdown from './scripts/multiselect-dropdown';
multiselectDropdown.init();

import * as dropdownPersist from './scripts/dropdown-persist';
dropdownPersist.init();

import * as scrollTop from './scripts/scroll-top';
scrollTop.init();

import * as heightChart from './scripts/height-chart';
heightChart.init();

import Collapse from 'bootstrap/js/dist/collapse';

import * as rangeSlider from '@elements/range-slider';
rangeSlider.init();

import * as conditionalForm from "./scripts/conditional-form";
conditionalForm.init();

import * as wishlist from './scripts/wishlist';
wishlist.init();

import * as imgContentSlider from './scripts/img-content-slider';
imgContentSlider.init();

import * as imageContentSlider from './scripts/image-content-slider';
imageContentSlider.init();

import * as contentSlider from './scripts/content-slider';
contentSlider.init();

import * as lightbox from '@elements/lightbox';
lightbox.init();

import * as lightboxAccessibility from './scripts/lightbox-accessibility';
lightboxAccessibility.init();

import * as circleAnimation from './scripts/circle-animation';
circleAnimation.init();

import * as rotateCircle from './scripts/rotate-circle';
rotateCircle.init();

import * as scrollToTop from './scripts/scroll-to-top';
scrollToTop.init();